import { Paragraph } from "@sicredi/react";
import style from "./styles.module.scss";

type BoletoAdesaoProps = {
  title: string;
  description: string;
};

export const TextBoletoAdesao: React.FC<BoletoAdesaoProps> = ({
  title,
  description,
}) => {
  return (
    <div className={style.container} data-testid="textBoletoAdesao-jest">
      <Paragraph size="medium">{title}</Paragraph>
      <Paragraph size="large" weight="bold">
        {description}
      </Paragraph>
    </div>
  );
};
